import { useEffect } from 'react';
import { PlayerRef } from '@remotion/player';
import { SelectionElementType } from '@goldcast/player-config/src/types/RemotionPlayerConfigTypes/CompositionConfig';
import { SelectionElementData, SelectionOutlineAction } from '@/App/remotion/components/Outlines/types';
import { CustomEvents } from '@/libs/eventBus/constants';
import EventBus from '@/libs/eventBus/eventBus';

export default function useRemotionPauseOnPlayerMenu({
  remotionPlayerRef
}: {
  remotionPlayerRef: React.RefObject<PlayerRef>;
}) {
  useEffect(() => {
    const handleGlobalSelectionAction = (payload: {
      action: SelectionOutlineAction;
      elementType?: SelectionElementType;
      data?: SelectionElementData;
    }) => {
      if (
        payload.action === SelectionOutlineAction.SELECT &&
        payload.elementType === SelectionElementType.VIDEO_IN_COMPOSITE &&
        remotionPlayerRef.current?.isPlaying()
      ) {
        remotionPlayerRef.current?.pause();
      }
    };

    const listener = EventBus.on(CustomEvents.SelectionOutlineAction, handleGlobalSelectionAction);

    return () => {
      EventBus.off(CustomEvents.SelectionOutlineAction, listener);
    };
  }, [remotionPlayerRef]);
}
